export default __webpack_public_path__ + "static/media/330_business01-it-web.f21ad073.png";